import { call, put, takeLeading } from 'redux-saga/effects';
import { Creators, Types } from '../../redux/auth/actions';
import { Creators as UserCreators, Types as UserTypes } from '../../redux/user/actions';
import {
	login as loginApi,
	changePassword as changePasswordApi,
} from '../../api/auth';

export function* login(actions) {
	try {
		const { vignet_number, pin } = actions;
		const response = yield call(loginApi, { vignet_number, pin });
    const { 
    	acess_token, address, chip_id, city, customer_id, email, 
    	first_name, mobile_phone, name, number, object_id, phone, 
    	postal_code, prefix, type_of_object, type_of_object_id 
    } = response.data;

    // store important details
    localStorage.setItem('access_token', acess_token); 
    localStorage.setItem('object', type_of_object); 
    localStorage.setItem('object_id', object_id);
    localStorage.setItem('user_id', customer_id);
    localStorage.setItem('chip_id', chip_id);

		yield put(Creators.loginSuccess(response.data));
	} catch (error) {
    let error_message = (error && error.response && error.response.data.errors.non_field_errors) || "Verkeerde referenties";
		yield put(Creators.loginFailure(error_message));
	}
}

export function* changePassword(actions) {
  try {
    const { history, payload } = actions;
    const response = yield call(changePasswordApi, actions.payload);
    yield put(Creators.changePasswordSuccess());
    history.push('/activate/step/five');
  } catch (error) {
    let error_message = (error && error.response && error.response.data.errors.non_field_errors) || "Bijwerken van wachtwoord mislukt";
    yield put(Creators.changePasswordFailure(error_message));
  }
}

export function* setVignetNumber(actions) {
  yield put(Creators.setVignetNumber(actions.vignet_number))
}

export function* watchLogin() {
  yield takeLeading(Types.LOGIN_REQUEST, login);
}

export function* watchChangePassword() {
  yield takeLeading(Types.CHANGE_PASSWORD, changePassword);
}

export function* watchSetVignetNumber() {
  yield takeLeading(Types.SET_VIGNET_NUMBER, setVignetNumber);
}

